import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-mist" data-id="element-184" data-mp="3fy2zzxxfvw4k">
      <div className="mx-auto max-w-letter px-4 py-7 sm:px-6 sm:py-8" data-id="element-185" data-mp="3b1cl3dxdf6kq">
        <h2 id="testimonios" className="text-center font-display text-xl uppercase leading-[1.1] tracking-tight text-brand-dark sm:text-3xl" data-id="element-186" data-mp="36yzgisud1epj">
          Lo que dicen quienes ya empezaron
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-center text-sm font-semibold leading-snug text-ink-muted" data-id="element-187" data-mp="2x006b5ty5b0f">
          De cero a comprender cómo funciona una instalación de seguridad.
        </p>

        <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-188" data-mp="v9oqvq9qrs5m">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-lg border border-line bg-white p-3.5 ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-189" data-mp="qa3qrciu5drb" data-mpi={i}>
              <div className="flex items-center gap-2" data-id="element-190" data-mp="78k5hgrsikt9">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-191" data-mp="7a4zn5a701ql">
                  {Array.from({
                length: 5
              }).map((_, j) => <StarIcon key={j} size={13} className="fill-gold text-gold" aria-hidden="true" data-id="element-192" data-mp="zw66ch9mvbcf" data-mpi={j} />)}
                </div>
                <QuoteIcon size={14} className="fill-line text-line" aria-hidden="true" data-id="element-193" data-mp="q4jxusoojqdd" />
              </div>
              <blockquote className="mt-1.5 text-[0.82rem] font-medium leading-snug text-ink sm:text-sm" data-id="element-194" data-mp="1itqybx7p2q19">
                “{t.quote}”
              </blockquote>
              <footer className="mt-auto pt-2" data-id="element-195" data-mp="1xiipsomnt6f0">
                <p className="text-[0.78rem] font-extrabold uppercase tracking-tight text-brand" data-id="element-196" data-mp="1xh7n6s4ya4ph">
                  {t.author}
                </p>
                <p className="text-[0.7rem] font-medium text-ink-muted" data-id="element-197" data-mp="1ogszxn8fefjc">
                  {t.role}
                </p>
              </footer>
            </Reveal>)}
        </ul>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-198" data-mp="1eiv52gw29khr">
          Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}